import { cn } from '@workspace/lib';
import { BinOptionItem } from './BinOptionItem';
import { BinOptionListProps } from '../binOptions.types';

export function BinOptionList({ items, hyperlinkText }: BinOptionListProps) {
  return (
    <div className="mx-auto w-full max-w-300">
      <div className={cn('grid w-full gap-6', 'grid-cols-1 md:grid-cols-3')}>
        {items?.map((item, index: number) => (
          <BinOptionItem key={item?._id ?? index} item={item} hyperlinkText={hyperlinkText} className="h-full w-full" />
        ))}
      </div>
    </div>
  );
}
